export const kpibasic = {
    kpifrequency: {
        service: {
            name: 'kpifrequency',
            title: 'KPI Frequency',
        }
    },
    objectivestate: {
        service: {
            name: 'objectivestate',
            title: 'Objective State',
        }
    },
    objectivetype: {
        service: {
            name: 'objectivetype',
            title: 'Objective Type',
        }
    },
    kpistate: {
        service: {
            name: 'kpistate',
            title: 'KPI State',
        }
    },
    kpitype: {
        service: {
            name: 'kpitype',
            title: 'KPI Type',
        }
    },
    kpiplanstate: {
        service: {
            name: 'kpiplanstate',
            title: 'KPI Plan State',
        }
    },
    kpiplantype: {
        service: {
            name: 'kpiplantype',
            title: 'KPI Plan Type',
        }
    },
    kpiperfstate: {
        service: {
            name: 'kpiperfstate',
            title: 'KPI Performance State',
        }
    },
    axis: {
        service: {
            name: 'axis',
            title: 'Axis',
        }
    },
}